/**
 * streamlines add a dynamic value to right.
 * @param {object} param0
 * @param {number|string} param0.$right
 * @returns {string}
 */
const dynRight = ({ $right }) => {
  if ($right === undefined) return "";
  if (typeof $right === "number") return `right: ${$right}px;`;
  return `right: ${$right};`;
};

export default dynRight;
